import { Environment, EnvironmentDomains } from './environment.model';

export const domains: EnvironmentDomains = {
  'https://cdf-dev.ext.eu-central-1.aws.cloud.bmw': {
    issuer: 'https://auth-i.bmwgroup.net:443/auth/oauth2/realms/root/realms/intranetb2x',
    clientId: 'e1835a93-6ef0-4475-8296-7583aca1edbd',
    realm: 'intranet',
  },
  'https://cdf-test.ext.eu-central-1.aws.cloud.bmw': {
    issuer: 'https://auth-i.bmwgroup.net:443/auth/oauth2/realms/root/realms/intranetb2x',
    clientId: 'a7ab02e4-5370-4ffb-9771-c606f2c6e7dd',
    realm: 'intranet',
  },
  'https://cdf.ext.eu-central-1.aws.cloud.bmw': {
    issuer: 'https://auth.bmwgroup.net:443/auth/oauth2/realms/root/realms/intranetb2x',
    clientId: '7cabb730-4f28-4e6c-9b9e-3bdd12d57eae',
    realm: 'intranet',
  },
  'https://cdf-dev.rspretailcrm.com': {
    issuer: 'https://auth-i.bmwgroup.com:443/auth/oauth2/realms/root/realms/internetb2x',
    clientId: '272b372f-f5cf-484e-9c0c-a83df3c0df99',
    realm: 'internet',
  },
  'https://cdf-test.rspretailcrm.com': {
    issuer: 'https://auth-i.bmwgroup.com:443/auth/oauth2/realms/root/realms/internetb2x',
    clientId: '2b6a9bde-407f-4f16-856f-fc94f3031f3b',
    realm: 'internet',
  },
  'https://cdf.rspretailcrm.com': {
    issuer: 'https://auth.bmwgroup.com:443/auth/oauth2/realms/root/realms/internetb2x',
    clientId: '1caaa678-d226-4caa-8b5d-8ca4ff60e900',
    realm: 'internet',
  },
};

export const environment: Environment = {
  // Is it a production environment? You can specify inside your code, which code will be executed in production mode.
  // Please use /src/app/services/config.service.ts -> isProdEnvironment() to check if it is a production environment.
  production: true,
  domains,
};
